import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export type RegisterMovelStage = 'cnpj-selection' | 'step2';

@Injectable({
  providedIn: 'root',
})
export class RegisterMovelFlowService {
  private readonly stageKey = 'register_movel_stage';
  private readonly addressKey = 'selectedCnpjAddress';
  private platformId = inject(PLATFORM_ID);


  private get storage(): Storage | null {
    return isPlatformBrowser(this.platformId) ? window.sessionStorage : null;
  }

  getStage(): RegisterMovelStage | null {
    const storage = this.storage;
    if (!storage) {
      return null;
    }

    const value = storage.getItem(this.stageKey);
    return value === 'cnpj-selection' || value === 'step2' ? (value as RegisterMovelStage) : null;
  }

  setStage(stage: RegisterMovelStage): void {
    this.storage?.setItem(this.stageKey, stage);
  }

  clearStage(): void {
    this.storage?.removeItem(this.stageKey);
  }

  setSelectedAddress(address: unknown): void {
    const storage = this.storage;
    if (!storage) {
      return;
    }

    if (address) {
      storage.setItem(this.addressKey, JSON.stringify(address));
    } else {
      storage.removeItem(this.addressKey);
    }
  }

  getSelectedAddress<T = unknown>(): T | null {
    const storage = this.storage;
    if (!storage) {
      return null;
    }

    const serialized = storage.getItem(this.addressKey);
    if (!serialized) {
      return null;
    }

    try {
      return JSON.parse(serialized) as T;
    } catch (error) {
      console.error('Failed to parse selected CNPJ address from sessionStorage:', error);
      storage.removeItem(this.addressKey);
      return null;
    }
  }

  clearSelectedAddress(): void {
    this.storage?.removeItem(this.addressKey);
  }

  reset(): void {
    this.clearStage();
    this.clearSelectedAddress();
  }
}

